function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      stroke: "var(--primary-color, #000)"
    },
    d: "M 51,36 C 51,36 40.030976,48 26.5,48 12.969024,48 2,36 2,36 2,36 12.969024,24 26.5,24 40.030976,24 51,36 51,36 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.83333331,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      stroke: "var(--primary-color, #000)"
    },
    d: "m 38,38 a 10,10 0 1 1 -20,0 10,10 0 1 1 20,0 z",
    transform: "matrix(1.2,0,0,1.2,-7.1,-10)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      fill: "var(--primary-color, #000)"
    },
    d: "m 34,37.5 a 5.5,5.5 0 1 1 -11,0 5.5,5.5 0 1 1 11,0 z",
    transform: "translate(-2,-2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      fill: "#fff"
    },
    d: "m 25,33.5 a 2.5,2.5 0 1 1 -5,0 2.5,2.5 0 1 1 5,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      stroke: "var(--primary-color, #000)"
    },
    d: "m 1,31 c 14,-15 37,-15 51,0"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Eye.08b0d615.svg";
export { ForwardRef as ReactComponent };